import { Reducer } from 'react';
import { CLEAR_PRIO_CACHE } from '../../../actions';
import {
  SET_ACTIVE_PROJECT_TAB_VIEW,
  ActiveProjectTabViewAction,
} from '../actions';
import { ProjectTabViews } from '../../../models/Types';

const reducer: Reducer<ProjectTabViews, ActiveProjectTabViewAction> = (
  state = 'myProjects',
  action
) => {
  switch (action.type) {
    case SET_ACTIVE_PROJECT_TAB_VIEW: {
      return action.activeTab;
    }
    case CLEAR_PRIO_CACHE: {
      return 'myProjects';
    }
    default:
      return state;
  }
};

export const getActiveProjectTabView = (state: string) => state;

export default reducer;
